var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2105 3H3.78947C1.70105 3 0 4.75067 0 6.9H16C16 4.75067 14.2989 3 12.2105 3ZM0 8.63333V12.1C0 14.2493 1.70105 16 3.78947 16H12.2105C14.2989 16 16 14.2493 16 12.1V8.63333H0ZM6.31579 12.9667H3.78947C3.32632 12.9667 2.94737 12.5767 2.94737 12.1C2.94737 11.6233 3.32632 11.2333 3.78947 11.2333H6.31579C6.77895 11.2333 7.15789 11.6233 7.15789 12.1C7.15789 12.5767 6.77895 12.9667 6.31579 12.9667Z",
    fill: "#474554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.9696421b3bea5a2e48802355aed5501a.svg";
export { ForwardRef as ReactComponent };